<template>
  <AsoftButton v-bind="attrs" :color="color" :loading="loading">
    <template v-for="(index, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
  </AsoftButton>
</template>

<script setup lang="ts">
import AsoftButton from "@/components/AtomSoftware/asoftButton.vue";

import { ref, useAttrs, computed } from "vue";

const $attrs = useAttrs();
const loading = ref(false);
const color = ref("btnclr");

// To stop the free fall of attributes
defineOptions({
  inheritAttrs: false,
});

const attrs = computed(() => {
  if ($attrs.color) {
    color.value = $attrs.color as string;
  }
  return { ...$attrs, onClick: handleClick };
});

async function handleClick() {
  try {
    loading.value = true;
    // console.log("In handle click...", loading.value);
    // console.log($attrs);
    // @ts-ignore
    await $attrs.onClick();
  } catch (error) {
    throw error;
  } finally {
    loading.value = false;
    // console.log("In handle click...", loading.value);
  }
}
</script>
